// extracted by mini-css-extract-plugin
export default {"img":"img_img__VgXi5","imageContainer":"img_imageContainer__K-ZAm"};